import { Col, Row, Input } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './styles.css';

class ShipmentRemark extends Component {
    render() {
        const { shipment } = this.props
        return (
            <Col span={30}>
                <Row gutter={16}>
                    <Col span={5} className="size-order-col-1">
                        <h1 className='title title-field'>SHIPMENT REMARK</h1>
                    </Col>
                    <Col span={30} className="size-order-col-2">
                        <Input
                            className="select-gutter-box"
                            value={shipment.ShipmentRemark}
                            disabled                            
                            isRedstar={false}
                            maxLength={100}
                        />
                    </Col>
                </Row>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {
        shipment: state.detailShipment.shipment,
        shipperInformation: state.detailShipment.shipperInformation,
    }
}
export default connect(
    mapStateToProps
)(ShipmentRemark)



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/shipment-remark/index.js